import { ApplicationRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { AppConfigsService } from '../../../../config/app-configs.service';
import { ScriptHelperService } from 'ClientApp/app/shared/services/script-load-helper.service';
import { IScriptAttribute } from 'ClientApp/app/shared/models/script-store/IOptions.interface';

@Component({
    selector: 'app-welcome-home',
    templateUrl: './welcome-home.component.html',
    styleUrls: ['./welcome-home.component.scss']
})
export class WelcomeHomeComponent implements OnInit, OnDestroy {
    constructor(
        private gtmService: GtmService,
        private appRef: ApplicationRef,
        private uiHelper: UiHelperService,
        private scriptHelper: ScriptHelperService,
        private appConfigs: AppConfigsService,        
    ) {}

    ngOnInit(): void {
        //this.gtmService.pushMain('virtual_page', 'NewHomePage/Anonymous', 'event', 'virtual_page');
        this.gtmService.pushDirective({ category: 'New website - anonymous', action: 'Load', label: 'Load' });
        this.appRef.isStable.subscribe((s) => {
            if (this.appConfigs.appConfigs.FLAG_ISHomepageExcoEnabled && this.uiHelper.isBrowser && s) {
                this.insertExco();
            }
        });

        //pushService is disabled by itay
        //if (this.uiHelper.isBrowser) {
        //    this.pushService.subscribeToNotifications();
        //}
    }

    insertExco(): void {
        if (document.getElementById('innernetwork')) {
            return;
        }
        const existing = document.getElementById('homepageExco');
        if (existing) {
            return;
        }

        const element = document.createElement('div');
        element.setAttribute('id', 'homepageExco');
        element.setAttribute('data-id', '319a5a9c-6d16-4955-929e-767a4cf65721');
        element.setAttribute('data-container', 'exco-noah');

        const attrs: IScriptAttribute[] = [
            {
                qualifiedName: 'id',
                value: 'homepageExcoScript'
            },
            {
                qualifiedName: 'type',
                value: 'text/javascript'
            }
        ];
        this.scriptHelper.singleScriptLoader(
            'https://smart-placements-sdk.ex.co/v1/18fb9c43-f34e-46c9-a65d-5bd50a6d4caf/sdk.js',
            'url',
            attrs,
            { defer: true }
        );

        document.body.appendChild(element);
    }

    removeExco(): void {
        document.querySelector('.placement[data-type=floating]')?.remove();
    }

    ngOnDestroy(): void {
        if (this.uiHelper.isBrowser) {
            this.removeExco();
        }
    }
}
